module.exports = __webpack_public_path__ + "static/img/cj04.ab9dd11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/cj04.png
// module id = 148
// module chunks = 0